"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuyerToConsumer = void 0;
const react_1 = __importDefault(require("react"));
const theme_1 = require("../utils/theme");
const css_manager_1 = require("@food/css-manager");
const Button_1 = require("@food/ui/build/dist/src/Button");
const style = (0, css_manager_1.registerClass)(() => `
	> div,
	> p {
		text-align: left;
	}
`);
const BuyerToConsumer = ({ t, user, isModal, proceed, supportEmail, }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("h2", null,
        t `Hello, `,
        " ",
        user.firstName,
        " ",
        user.lastName),
    react_1.default.createElement("section", { className: style },
        react_1.default.createElement("div", null, t `Thanks for validating.`),
        react_1.default.createElement("p", null, t `The email domain you used matches with a company unrelated to the food supply chain.`),
        react_1.default.createElement("p", null, t `We can't give you a Business Profile.`),
        react_1.default.createElement("div", null,
            t `If you think we're wrong please`,
            ' ',
            react_1.default.createElement("a", { href: `mailto:${supportEmail}` }, t `contact us`)),
        react_1.default.createElement("div", { className: (0, css_manager_1.classNames)(theme_1.footer, 'centered') },
            react_1.default.createElement(Button_1.Button, { label: t(isModal ? 'Close' : 'Proceed'), onClick: proceed })))));
exports.BuyerToConsumer = BuyerToConsumer;
//# sourceMappingURL=BuyerToConsumer.js.map